import { prop } from 'ramda'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'app/store'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'
import { SessionState, sessionActions, sessionStoreKey } from 'core/session/sessionReducers'
import { isAdminRole } from 'core/utils/rbac'

const adminOptions = [
  { label: 'Shared', value: 'shared' },
  { label: 'Public', value: 'public' },
  { label: 'Private', value: 'private' },
]

const options = [
  { label: 'Shared', value: 'shared' },
  { label: 'Private', value: 'private' },
]

interface Props {}

export default function VisibilityPicklist({
  name = 'visibility',
  label = 'Visibility',
  compact = false,
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  const session = useSelector<RootState, SessionState>(prop(sessionStoreKey))
  const isAdmin = useMemo(() => isAdminRole(session), [session])
  const dropdownOptions = isAdmin ? adminOptions : options
  return (
    <AsyncDropdown compact={compact} name={name} label={label} items={dropdownOptions} {...rest} />
  )
}
